


















import { PropType, computed, defineComponent } from '@vue/composition-api';
import { Message, MessageType } from '../../dataType';
import { VueConstructor } from 'vue';
import { useMessage } from '../../hooks/useMessage';

import Text from './Text.vue';
import BotText from './BotText.vue';
import AskQuestion from './AskQuestion.vue';
import SprintRiskStatus from './SprintRiskStatus.vue';
import Markdown from './Markdown.vue';
import ReportCard from './report-card/index.vue';
import NoneData from './NoneData.vue';
import FilterRecommend from './FilterRecommend.vue';
import IssueList from './IssueList.vue';
import ChooseProject from './ChooseProject.vue';
import Automation from './Automation.vue';
import Intention from './Intention.vue';
import IntentionBack from './IntentionBack.vue';
import IntentionBackQuestion from './IntentionBackQuestion.vue';
import Waiting from './Waiting.vue';
import dayjs from 'dayjs';

type ComponentMap = {
  [K in MessageType]?: VueConstructor
}

const components: ComponentMap = {
  'ai.sendText': Text,
  'ai.waiting': Waiting,
  'ai.receiveRecommendData': AskQuestion,
  'ai.markdown': Markdown,
  'ai.receive.report.data': ReportCard,
  'ai.text': BotText,
  'ai.noneData': NoneData,
  'ai.receiveRecommendDataFilter': FilterRecommend,
  'ai.issue': IssueList,
  'ai.automation.ask.project': ChooseProject,
  'ai.automation.error': Markdown,
  'ai.automation': Automation,
  'ai.chooseProjectList': ChooseProject,
  'ai.intention': Intention,
  'ai.intentionBack': IntentionBack,
  'ai.example': IntentionBackQuestion,
  'ai.continueResult': FilterRecommend,
  'ai.sprint.risk.status': SprintRiskStatus
};

export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props) {
    const isRobot = computed<boolean>(() => props.message.userId === 0);
    const { isWaitResponse } = useMessage();
    const createTime = computed(() => {
      return props.message.createTime;
    });

    return {
      dayjs,
      isRobot,
      createTime,
      isWaitResponse,
      component: computed(() => components[props.message.type || 'ai.sendText'])
    };
  }
});
